import "../App.css";
import { Slider } from "./Slider";
import { WindowContext } from "../App";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

function WindowSize() {
  const { currentWindow } = useContext(WindowContext);
  const { t } = useTranslation();

  const maxWidth = currentWindow.toLowerCase().includes("3w") ? 360 : 240;

  return (
    <>
      <div className="panel-section">
        <div className="section-header section">{t("window_size")}</div>
        <div className="line"></div>
        <Slider
          idSlider={"width"}
          tittle={t("width")}
          minSlider={100}
          maxSlider={maxWidth}
          stepSlider={10}
          // editable={true}
          iniValue={200}
          unit={t("unit")}
          editable={true}
          sliderOff={0}
        />
        <div style={{ margin: "20px auto" }} />
        {/* {currentWindow.includes("fb") ? (
          <>
            <CustomInputBox
              id={"height"}
              tittle={"Height"}
              placeholder={1.8}
              step={0.1}
              min={1}
              max={2.4}
              editable={false}
              unit={"m"}
            />
          </>
        ) : (
          <> */}
        <Slider
          idSlider={"height"}
          tittle={t("height")}
          // placeholder={1.4}
          stepSlider={10}
          minSlider={100}
          maxSlider={180}
          iniValue={180}
          unit={t("unit")}
          editable={currentWindow.toLowerCase().includes("fb") ? false : true}
          sliderOff={currentWindow.toLowerCase().includes("fb") ? 1 : 0}
        />
        {/* </>
        )} */}
      </div>
    </>
  );
}

export default WindowSize;
